import {I18n} from '@aws-amplify/core';
import {PaymentIntent} from '../types';
import {StripeAmount} from "../../../components/StripeAmount.tsx";
import {StatusBadge} from "../profile/StatusBadge.tsx";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {NavLink} from 'react-router-dom';

export const getColumns = (onRecordClick?: (record: PaymentIntent) => void) => [
    {
        title: I18n.get('Amount'),
        width: '1fr',
        render: (item: PaymentIntent) => onRecordClick ? (
            <span
                style={{color: 'var(--mantine-color-blue-6)', cursor: 'pointer'}}
                onClick={() => onRecordClick(item)}
            >
                <StripeAmount amount={item.amount} currency={item.currency}/>
            </span>
        ) : <StripeAmount amount={item.amount} currency={item.currency}/>,
    },
    {
        title: I18n.get('Currency'),
        width: '1fr',
        render: (item: PaymentIntent) => item.currency,
    },
    {
        title: I18n.get('Customer'),
        width: '1fr',
        render: (item: PaymentIntent) => item.customerId ? <NavLink to={`/customers/${item.customerId}`}>{item.customerId}</NavLink> : '-',
    },
    {
        title: I18n.get('Description'),
        width: '1fr',
        render: (item: PaymentIntent) => item.description,
    },
    {
        title: I18n.get('Status'),
        width: '1fr',
        render: (item: PaymentIntent) => <StatusBadge status={item.status}/>,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: PaymentIntent) => formatTimestamp(item.created * 1000),
    },
];

// Keep backward-compatible export for any remaining consumers
export const columns = getColumns();
